import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { getRecentProject } from "@/helpers/recent-project";
import { useLinkedProjects } from "@/hooks/Network/useLinkedProjects";
import { useQueryParam } from "@/hooks/useQueryParam";

export function SlugRedirect(): React.ReactNode {
  const { data: projects, error } = useLinkedProjects();
  const location = useLocation();
  const navigate = useNavigate();
  const [projectIdQueryParam] = useQueryParam("projectId");

  useEffect(() => {
    if (!projects) {
      return;
    }

    if (projects.length > 0) {
      const slugFromQueryParam = projectIdQueryParam
        ? projects.find((x) => x.id === projectIdQueryParam)?.slug
        : undefined;
      const slug = slugFromQueryParam || getRecentProject(projects).slug;

      void navigate(`/@/${slug}${location.pathname}`);
    } else {
      void navigate("/");
    }
  }, [location.pathname, navigate, projectIdQueryParam, projects]);

  if (error) {
    return <ErrorPage error={error} />;
  }

  return null;
}
